import dayjs from 'dayjs';

export const formattingDate = (date: Date | null) => {
  return date ? dayjs(date).format('MMM. DD, YYYY') : '-';
};

export const changeDateToFilter = (date: Date | null) => {
  return new Date(dayjs(date).add(1, 'day').toString());
};
